/**
 * リレー計算 フロントエンドスクリプト
 */

(function ($) {
	'use strict';

	// ゲームの状態
	const GameState = {
		IDLE: 'idle',
		PLAYING: 'playing',
		ANSWERED: 'answered',
		RESULT: 'result'
	};

	// 演算子タイプ
	const OperationType = {
		ADDITION: 'addition',
		SUBTRACTION: 'subtraction',
		MIXED: 'mixed'
	};

	$(function () {
		// 各ブロックを初期化
		$('.relay-calc-block').each(function () {
			const blockId = $(this).attr('id');

			// このブロックのデータを取得
			if (typeof brainTrainingRelayCalc === 'undefined' ||
				!brainTrainingRelayCalc[blockId]) {
				console.error('リレー計算データが見つかりません');
				return;
			}

			const gameData = brainTrainingRelayCalc[blockId];
			initializeBlock(blockId, gameData);
		});
	});

	/**
	 * ブロックを初期化
	 */
	function initializeBlock(blockId, gameData) {
		const $block = $('#' + blockId);
		const $problemPhase = $block.find('.problem-phase');
		const $resultPhase = $block.find('.result-phase');
		const $startButton = $block.find('.start-game-button');
		const $calculationDisplay = $block.find('.calculation-display');
		const $timerDisplay = $block.find('.time-value');
		const $answerForm = $block.find('.answer-form');
		const $answerInput = $block.find('.answer-input');
		const $submitButton = $block.find('.submit-answer-button');
		const $retryButton = $block.find('.retry-button');

		let gameState = GameState.IDLE;
		let timer = null;
		let startTime = 0;
		let endTime = 0;
		let timeLimit = gameData.timeLimit;
		let problemCount = gameData.problemCount;
		let minNumber = gameData.minNumber;
		let maxNumber = gameData.maxNumber;
		let operationType = gameData.operationType;

		let calculationSteps = [];
		let finalAnswer = 0;

		// 開始ボタンのイベント
		$startButton.on('click', function () {
			startGame();
		});

		// 回答送信ボタンのイベント
		$submitButton.on('click', function () {
			submitAnswer();
		});

		// エンターキーで回答送信
		$answerInput.on('keypress', function (e) {
			if (e.which === 13) {
				submitAnswer();
			}
		});

		// もう一度挑戦ボタンのイベント
		$retryButton.on('click', function () {
			resetGame();
		});

		/**
		 * ゲーム開始
		 */
		function startGame() {
			// 状態をリセット
			gameState = GameState.PLAYING;
			startTime = Date.now();

			// 計算問題を生成
			generateCalculation();

			// UIを更新
			$startButton.hide();
			$answerForm.show();
			$answerInput.val('').focus();

			// タイマー開始
			startTimer();
		}

		/**
		 * 計算問題の生成
		 */
		function generateCalculation() {
			calculationSteps = [];
			let currentValue = getRandomNumber(minNumber, maxNumber);

			// 最初の数値
			calculationSteps.push({
				value: currentValue,
				operation: null,
				operand: null
			});

			// 各ステップの計算を生成
			for (let i = 0; i < problemCount; i++) {
				let operation, operand;

				// 演算子タイプに基づいて演算子を選択
				if (operationType === OperationType.ADDITION) {
					operation = '+';
				} else if (operationType === OperationType.SUBTRACTION) {
					operation = '-';
				} else { // MIXED
					// ランダムに足し算か引き算を選択
					operation = Math.random() < 0.5 ? '+' : '-';
				}

				// 引き算の場合、答えがマイナスにならないようにオペランドを選択
				if (operation === '-') {
					// 現在値より小さい数をランダムに選択
					operand = getRandomNumber(minNumber, Math.min(currentValue, maxNumber));
				} else {
					// 通常範囲内でランダムな数を選択
					operand = getRandomNumber(minNumber, maxNumber);
				}

				// 計算実行
				if (operation === '+') {
					currentValue += operand;
				} else {
					currentValue -= operand;
				}

				// 計算ステップを追加
				calculationSteps.push({
					value: currentValue,
					operation: operation,
					operand: operand
				});
			}

			// 最終的な答えを設定
			finalAnswer = currentValue;

			// 計算式を表示
			displayCalculation();
		}

		/**
		 * 計算式の表示
		 */
		function displayCalculation() {
			$calculationDisplay.empty();

			// 最初の数値
			const $calculation = $('<div class="calculation-steps"></div>');
			$calculation.append($('<div class="calculation-step start-number"></div>').text(calculationSteps[0].value));

			// 各ステップの計算を表示（答えは表示しない）
			for (let i = 1; i < calculationSteps.length; i++) {
				const step = calculationSteps[i];
				const $step = $('<div class="calculation-step"></div>').text(
					`${step.operation} ${step.operand}`
				);
				$calculation.append($step);
			}

			$calculationDisplay.append($calculation);
		}

		/**
		 * ランダムな数値を取得
		 */
		function getRandomNumber(min, max) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		}

		/**
		 * タイマー開始
		 */
		function startTimer() {
			let timeLeft = timeLimit;
			$timerDisplay.text(timeLeft);

			timer = setInterval(function () {
				timeLeft--;
				$timerDisplay.text(timeLeft);

				if (timeLeft <= 0) {
					clearInterval(timer);
					// 時間切れの場合、自動的に回答処理
					gameState = GameState.ANSWERED;
					endTime = Date.now(); // 終了時間を記録
					showResult(false, 'タイムアップ！');
				}
			}, 1000);
		}

		/**
		 * 回答を送信
		 */
		function submitAnswer() {
			if (gameState !== GameState.PLAYING) return;

			const userAnswer = $answerInput.val().trim();

			// 未入力チェック
			if (userAnswer === '') {
				alert('答えを入力してください');
				return;
			}

			// 数値チェック
			if (isNaN(parseFloat(userAnswer))) {
				alert('数値を入力してください');
				return;
			}

			// タイマーを停止
			clearInterval(timer);
			endTime = Date.now();

			// 回答状態に更新
			gameState = GameState.ANSWERED;

			// 正解判定
			const isCorrect = parseInt(userAnswer) === finalAnswer;
			showResult(isCorrect);
		}

		/**
		 * 結果表示
		 */
		function showResult(isCorrect, message = '') {
			gameState = GameState.RESULT;

			// 経過時間を計算
			const timeUsed = Math.floor((endTime - startTime) / 1000);

			// 結果テキストを設定
			let resultText;
			if (message) {
				resultText = message;
			} else {
				resultText = isCorrect ? '正解です！' : `不正解です。正しい答えは ${finalAnswer} です。`;
			}

			// 結果を表示
			$block.find('.answer-result').text(resultText);
			$block.find('.time-used').text(`経過時間: ${timeUsed} 秒`);

			// 計算履歴を表示
			const $calcHistory = $block.find('.calculation-history');
			$calcHistory.empty();

			// 計算過程のタイトル
			$calcHistory.append($('<h4>計算過程</h4>'));

			// 計算過程の表示
			const $calcSteps = $('<div class="calculation-steps-history"></div>');
			$calcSteps.append($('<div class="calculation-step-history start-value"></div>').text(`開始値: ${calculationSteps[0].value}`));

			// 各ステップの計算を表示（結果画面では答えも表示）
			for (let i = 1; i < calculationSteps.length; i++) {
				const step = calculationSteps[i];
				const $step = $('<div class="calculation-step-history"></div>').text(
					`ステップ ${i}: ${step.operation} ${step.operand} = ${step.value}`
				);
				$calcSteps.append($step);
			}

			$calcHistory.append($calcSteps);

			// 結果画面を表示
			$problemPhase.hide();
			$resultPhase.show();
		}

		/**
		 * ゲームリセット
		 */
		function resetGame() {
			// タイマーをクリア
			if (timer) {
				clearInterval(timer);
			}

			// ゲーム状態をリセット
			gameState = GameState.IDLE;

			// UI表示をリセット
			$timerDisplay.text(timeLimit);
			$calculationDisplay.empty();
			$answerInput.val('');

			// 各フェーズの表示状態を変更
			$resultPhase.hide();
			$problemPhase.show();
			$startButton.show();
			$answerForm.hide();
		}

		// 初期状態を設定
		resetGame();
	}

})(jQuery);